export const params = ['aaap'];

export function handler(value, urlSearchParams) {
    import('../affiliates/saveaffiliates.js').then(({ default: saveAffiliates }) => saveAffiliates(value, urlSearchParams));
}

